import React from "react";

export function SortButton({label, field, sort, onSort}) {
    const active = sort.field === field;
    const indicator = active ? (sort.direction === "asc" ? "↑" : "↓") : "↕";
    return (
        <button
            type="button" className="sort-button" onClick={() => onSort(field)}
            aria-label={`Sort by ${label}`}
        >
            <span>{label}</span>
            <span className={`sort-indicator ${active ? "active" : ""}`} aria-hidden="true">{indicator}</span>
        </button>
    );
}

export function SortHeader({label, field, sort, onSort, numeric = false}) {
    const ariaSort = sort.field === field ? (sort.direction === "asc" ? "ascending" : "descending") : "none";
    return (
        <th className={numeric ? "num" : ""} aria-sort={ariaSort}>
            <SortButton
                label={label} field={field} sort={sort}
                onSort={onSort}
            />
        </th>
    );
}

export function sortRows(rows, sort, valueFor) {
    if (!sort.field) return rows;
    return [...rows].sort((left, right) => {
        const a = valueFor(left, sort.field);
        const b = valueFor(right, sort.field);
        if (a == null && b == null) return 0;
        if (a == null) return 1;
        if (b == null) return -1;
        const result = typeof a === "number" && typeof b === "number"
            ? a - b
            : String(a).localeCompare(String(b), undefined, {numeric: true, sensitivity: "base"});
        return sort.direction === "asc" ? result : -result;
    });
}
